import styled from 'styled-components';

import alert from '../../../assets/alert.svg';
import colors from '../../../styles/colors';

interface ContainerProps {
  hasLabel: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: ${(props) => (props.hasLabel ? '0px' : '10px 0 5px 0;')} !important;

  .react-select__control {
    border: 1px solid ${colors.gray};
    transition: border 0.3s;
  }
  .react-select__control--is-focused {
    border-color: ${colors.darkgray};
    box-shadow: 0 0 0 0;
    &:hover {
      border-color: ${colors.darkgray};
    }
  }

  .react-select__placeholder {
    color: ${colors.gray};
  }

  .react-select__menu {
    display: block;
    visibility: visible;
  }

  &.Select--multi {
    .Select-value {
      display: inline-flex;
      align-items: center;
    }
  }

  & .Select-placeholder {
    font-size: smaller;
  }
  span:last-child {
    color: #c11e1e;
    margin: 5px 0;
  }
  span:last-child:before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;

export const LabelContainer = styled.div`
  margin: 10px 0 5px 0;

  label {
    font-weight: bold;
  }
  small {
    color: ${colors.gray};
    font-size: 14px;
  }
`;
